import React__default, { useRef, useState, useEffect } from 'react';
import { TaktIdProvider, createStormTaktId, Flex } from '@amzn/storm-ui';
import { P as PageHeaderWrapper, T as TitleTextWrapper, a as TitleText, A as AttributesAndActionsWrapper } from './PageHeader.styles-Cie6D6me.js';
import { A as AttributesContainer } from './attributes/AttributesContainer-OBn8Of09.js';
import { A as ActionsContainer } from './actions/ActionsContainer-BWOH6H61.js';
import { g as getTranslationComponent } from '../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { I as IntlProvider } from '../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DmRs8GLp-yq9BpgTU.js';

const PageHeader = ({
  title,
  prefix,
  renderPageTitleIcon,
  renderAttributes,
  renderActions,
  attributesErrorMessage,
  actionsErrorMessage,
  taktId,
  taktValue,
  locale = 'en-US',
  ...props
}) => {
  const hasActionsOrAttributes = !!renderAttributes || !!renderActions;
  const hasActionsAndAttributes = !!renderAttributes && !!renderActions;
  const attributesContainerRef = useRef(null);
  const actionsContainerRef = useRef(null);
  const [isActionsContainerWrapped, setIsActionsContainerWrapped] = useState(false);

  // Required to detect whether the actions are wrapped to the next line inside the parent div.
  // This is required in order to ensure the error message is left-aligned
  useEffect(() => {
    const detectWrap = () => {
      const attributesContainer = attributesContainerRef.current;
      const actionsContainer = actionsContainerRef.current;
      const attributesRect = attributesContainer === null || attributesContainer === void 0 ? void 0 : attributesContainer.getBoundingClientRect();
      const actionsRect = actionsContainer === null || actionsContainer === void 0 ? void 0 : actionsContainer.getBoundingClientRect();

      // Determine if actionsContainer is wrapped
      if (actionsRect && attributesRect) {
        const wrapped = actionsRect.top > attributesRect.top;
        setIsActionsContainerWrapped(wrapped); // Update state
      }
    };
    if (hasActionsAndAttributes && attributesErrorMessage) {
      detectWrap(); // Run detection on initial render
      window.addEventListener('resize', detectWrap);
    }
    return () => {
      window.removeEventListener('resize', detectWrap);
    };
  }, [hasActionsAndAttributes, attributesErrorMessage]);
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    resetKey: locale,
    translations: getTranslationComponent(locale)
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header')
  }, /*#__PURE__*/React__default.createElement(PageHeaderWrapper, props, title && /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    columnGap: "xxsmall",
    wrap: "wrap"
  }, /*#__PURE__*/React__default.createElement(TitleTextWrapper, {
    renderAs: "h1",
    size: "large",
    "data-testid": "page-header-title"
  }, prefix && /*#__PURE__*/React__default.createElement("span", null, `${prefix}:`), /*#__PURE__*/React__default.createElement(TitleText, {
    hasPrefix: !!prefix
  }, title)), renderPageTitleIcon === null || renderPageTitleIcon === void 0 ? void 0 : renderPageTitleIcon()), hasActionsOrAttributes && /*#__PURE__*/React__default.createElement(AttributesAndActionsWrapper, {
    hasActionsWithNoAttributes: !!renderActions && !renderAttributes
  }, !!renderAttributes && /*#__PURE__*/React__default.createElement(AttributesContainer, {
    errorMessage: attributesErrorMessage,
    ref: attributesContainerRef
  }, renderAttributes()), !!renderActions && /*#__PURE__*/React__default.createElement(ActionsContainer, {
    errorMessage: actionsErrorMessage,
    isWrapped: isActionsContainerWrapped,
    ref: actionsContainerRef
  }, renderActions())))));
};

export { PageHeader as P };
//# sourceMappingURL=PageHeader-DxLCfpA4.js.map
